// Import extend function.
import Component from '../../../js/core/component.js';
import isVisible from '../../../js/utilities/is-visible/u-is-visible.js';

class FormSummary extends Component {

	_defaultSettings () {
		return {
			debug: false
		};
	}

	_init () {
		if (this.inited) {
			this._log('Summary is already inited');
			return;
		}

		this.inited = true;
	}

	createPreviewButton () {
		let previewButton = document.createElement('button');
		previewButton.type = 'button';
		previewButton.classList.add('c-button');
		previewButton.id = 'preview-button';
		previewButton.innerHTML = 'Förhandsgranska';
		previewButton.setAttribute('aria-controls', 'form-summary');

		return previewButton;
	}

	createClosePreviewButton () {
		let closePreviewButton = document.createElement('button');
		closePreviewButton.type = 'button';
		closePreviewButton.classList.add('c-button', 't-space-left-s');
		closePreviewButton.id = 'close-preview-button';
		closePreviewButton.innerHTML = 'Ändra uppgifter';
		closePreviewButton.setAttribute('aria-controls', 'form-wrapper');
		closePreviewButton.style.display = 'none';

		return closePreviewButton;
	}

	toggleFormAndSummary (whatToShow, settings) {
		if (whatToShow === 'summary') {
			settings.formContainer.style.display = 'none';
			settings.previewButton.style.display = 'none';
			settings.submitButton.style.display = 'inline-flex';
			settings.submitButton.disabled = false;
			settings.closePreviewButton.style.display = 'inline-flex';
			if (settings.errorSummary) {
				settings.errorSummary.style.display = 'none';
			}

			history.pushState(null, null, '#summary');
		}
		else {
			settings.summaryDestination.innerHTML = '';
			settings.formContainer.style.display = 'block';
			settings.previewButton.style.display = 'inline-flex';
			settings.submitButton.style.display = 'none';
			settings.submitButton.disabled = true;
			settings.closePreviewButton.style.display = 'none';
			if (settings.errorSummary) {
				settings.errorSummary.style.display = 'block';
			}
		}
	}

	createSummary (fieldsetsToCheck, summaryDestination) {
		summaryDestination.innerHTML = '';
		let summary = document.createElement('div');
		summary.id = 'summary';

		fieldsetsToCheck.forEach(item => {
			if (!isVisible(item)) {
				return;
			}
			let fieldset = item.cloneNode();
			let legend = item.querySelector('legend').cloneNode(true);
			fieldset.appendChild(legend);
			let list = this._createKeyValueArray(item);

			let dl = document.createElement('dl');
			dl.classList.add('c-label-value-list', 'c-label-value-list--summary');
			list.forEach(item => {
				let row = document.createElement('div');
				row.classList.add('c-label-value-list__item');
				if (item.values[0] instanceof HTMLElement) {
					row.classList.add('c-label-value-list__item--full');
				}
				dl.appendChild(row);

				let dt = document.createElement('dt');
				dt.classList.add('c-label-value-list__label');
				dt.innerHTML = item.label;
				row.appendChild(dt);

				let dd = document.createElement('dd');
				dd.classList.add('c-label-value-list__value');
				item.values.forEach(value => {
					if (typeof value === 'string') {
						let p = document.createElement('p');
						p.innerHTML = value;
						dd.appendChild(p);
					}
					else {
						dd.appendChild(value);
					}
				});
				row.appendChild(dd);
			});

			fieldset.appendChild(dl);
			summary.appendChild(fieldset);
		});

		return summary;
	}

	_createKeyValueArray (fieldset) {
		let items =	Array.from(fieldset.querySelectorAll('[data-control]'));
		let list = [];

		items.forEach(item => {
			let type = item.dataset.control;
			if (!isVisible(item)) {
				return;
			}

			let label;
			let values;
			switch (type) {
				case 'select':
					label = item.querySelector('label').childNodes[0].nodeValue;
					values = this._findSelectControlAndGetValues(item);
					break;
				case 'checkbox':
					label = item.querySelector('label').childNodes[0].nodeValue;
					values = this._findCheckboxControlAndGetValues(item);
					break;
				case 'checkbox-group':
				case 'radio-group':
					label = item.querySelector('legend').childNodes[0].nodeValue;
					values = this._findGroupControlsAndGetValues(item);
					break;
				case 'data':
				case 'formula':
					label = item.querySelector('dt').innerHTML;
					values = this._findDataAndGetValues(item);
					break;
				case 'map':
					label = item.querySelector('[data-form-map="label"]').childNodes[0].nodeValue;
					values = this._findMapAndGetValues(item);
					break;
				default:
					label = item.querySelector('label').childNodes[0].nodeValue;
					values = this._findRegularControlAndGetValues(item);
					break;
			}

			list.push({label: label, values: values});
		});

		return list;
	}

	_findMapAndGetValues (item) {
		let preview = document.createElement('img');
		let src = item.querySelector('[data-form-map="map-img-preview"]').src;
		preview.src = src;
		preview.alt = 'Förhandsvisning av val utpekat på karta';
		return [preview];
	}

	_findRegularControlAndGetValues (item) {
		let control = item.querySelector('input, textarea');
		let unit = item.querySelector('.c-form-item__unit');

		if (unit) {
			return [`${control.value} ${unit.innerHTML}`];
		}
		else if (control.type == 'file') {
			if (control.files[0]) {
				return [control.files[0].name];
			}
			else {
				return [''];
			}
		}
		else {
			return [control.value];
		}
	}

	_findSelectControlAndGetValues (item) {
		let control = item.querySelector('select');
		return [control.options[control.selectedIndex].text];
	}

	_findGroupControlsAndGetValues (item) {
		let type = item.dataset.control.replace('-group', '');
		let controls = Array.from(item.querySelectorAll(`input[type="${type}"]`));
		let values = [];

		controls.forEach(control => {
			if (control.checked) {
				values.push(item.querySelector(`label[for="${control.id}"]`).innerHTML);
			}
		});

		return values;
	}

	_findCheckboxControlAndGetValues (item) {
		let control = item.querySelector('input');
		let values = [];
		let value;

		if (control.checked) {
			value = control.dataset.labelTrue ? control.dataset.labelTrue : 'Ja';
		}
		else {
			value = control.dataset.labelFalse ? control.dataset.labelFalse : 'Nej';
		}
		values.push(value);

		return values;
	}

	_findDataAndGetValues (item) {
		let dd = item.querySelector('dd');

		return [dd.innerHTML];
	}
}

export default FormSummary;



// WEBPACK FOOTER //
// ./components/form-elements/form/c-form-summary.js